<template>
    <div class="marketing-site-header">
        <div class="left">
            <ds-icon-button name="x" @click="$emit('close-editor')" />

            <div class="header-text">
                <h4>{{ header }}</h4>
                <p>{{ title }}</p>
            </div>
        </div>

        <div class="right">
            <template v-if="!isTemplateSaved">
                <ds-spinner v-if="isSaving" data-qa="saving-spinner" />

                <ds-outline-button
                    v-else
                    data-qa="update-button"
                    leading-icon="save"
                    :disabled="saveDisabled"
                    @click="$emit('update')"
                >
                    {{ $options.ACTIONS.SAVE }}
                </ds-outline-button>

                <ds-filled-button
                    data-qa="publish-from-header"
                    @click="$emit('publish')"
                >
                    {{ $options.ACTIONS.PUBLISH }}
                </ds-filled-button>
            </template>

            <ds-filled-button
                v-else
                :leading-icon="isSaving ? 'more-horizontal' : 'save'"
                :disabled="saveDisabled"
                @click="$emit('save-template')"
            >
                {{ $options.ACTIONS.SAVE_EXIT }}
            </ds-filled-button>

            <ds-dropdown
                disable-scroll
                icons
                position="bottom-end"
            >
                <ds-icon-button name="more-vertical" />

                <ul slot="menu" class="dropdown-menu-list">
                    <li
                        class="dropdown-menu-item"
                        @click.prevent="$emit('save-as-a-template')"
                    >
                        <ds-icon name="form" />
                        <span>{{ $options.ACTIONS.TEMPLATE_SAVE }}</span>
                    </li>
                    <li
                        class="dropdown-menu-item"
                        @click.prevent="$emit('share-feedback')"
                    >
                        <ds-icon name="message-square" />
                        <span>{{ $options.ACTIONS.SHARE }}</span>
                    </li>
                </ul>
            </ds-dropdown>
        </div>
    </div>
</template>

<script>
import { TEMPLATE_STATUS } from '../util/marketing/unlayer.constants';

export const TEMPLATE_GROUP_EDIT = 'Edit landing page';
export const TEMPLATE_GROUP_CREATE = 'Create landing page';
export const ACTIONS = {
    SAVE: 'Save',
    SAVE_EXIT: 'Save and Exit',
    PUBLISH: 'Publish',
    TEMPLATE_SAVE: 'Save as a Template',
    SHARE: 'Share feedback',
};
export const SITE_STATUS = {
    PUBLISHED: 'ACTIVE',
    PUBLISHED_CHANGES: 'ACTIVE_CHANGES',
    DRAFT: 'DRAFT',
    SAVED: 'SAVED',
};

export default {
    ACTIONS,
    props: {
        isSaving: {
            type: Boolean,
        },
        template: {
            type: Object,
        },
        publishDisabled: {
            type: Boolean,
        },
        saveDisabled: {
            type: Boolean,
        },
    },

    computed: {
        header() {
            if (this.template?.templateGroupStatus === SITE_STATUS.DRAFT) {
                return TEMPLATE_GROUP_CREATE;
            }

            return TEMPLATE_GROUP_EDIT;
        },
        title() {
            if (this.template?.title) {
                return this.template.title;
            }

            return '';
        },
        isTemplateSaved() {
            return this.template?.templateGroupStatus === TEMPLATE_STATUS.Saved;
        },
    },
};
</script>

<style lang="scss" scoped>
.marketing-site-header {
    width: 100vw;
    height: px-to-rem(56px);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    .left {
        gap: $spacing-050;
    }

    .right {
        gap: $spacing-200;
    }
}

.header-text p {
    color: $color-ink-800;
    font-size: $font-size-xs;
    margin: 0;
}

.dropdown-menu-list {
    width: px-to-rem(250px);
    padding: $spacing-150 0;
    margin: auto;
}

.dropdown-menu-item {
    --icon-color: #{$color-gray-700};
}
</style>
